import { ControlledSelect, ControlledTextField } from '@if/mui'
import { MenuItem, Stack } from '@mui/material'
import { SelectValueListItem } from '@src/types/SelectValueListItem'
import { useMemo } from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  beneficiaryTypes: SelectValueListItem[]
  isVeterinaryLoanPurpose: boolean
  disableOtherName: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formControl: Control<any>
}

const BeneficiaryForm = ({ beneficiaryTypes, isVeterinaryLoanPurpose, disableOtherName, formControl }: Props) => {
  const { t } = useTranslation()
  const beneficiaryTypeOptions = useMemo(
    () =>
      beneficiaryTypes.map((item) => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      )),
    [beneficiaryTypes],
  )

  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 1 }}>
      <ControlledSelect
        name="beneficiaryTypeId"
        control={formControl}
        label={t('editCreditApplication.beneficiary.beneficiary')}
        options={beneficiaryTypeOptions}
        disabled={isVeterinaryLoanPurpose}
        fullWidth
      />
      {!isVeterinaryLoanPurpose && (
        <ControlledTextField
          id="otherBeneficiaryFirstName"
          name="otherBeneficiaryFirstName"
          control={formControl}
          label={t('editCreditApplication.beneficiary.otherBeneficiaryFirstName')}
          disabled={disableOtherName}
          slotProps={{ htmlInput: { maxLength: 50 } }}
          fullWidth
        />
      )}
      <ControlledTextField
        id="otherBeneficiaryLastName"
        name="otherBeneficiaryLastName"
        control={formControl}
        label={
          !isVeterinaryLoanPurpose
            ? t('editCreditApplication.beneficiary.otherBeneficiaryLastName')
            : t('editCreditApplication.beneficiary.animalName')
        }
        required={isVeterinaryLoanPurpose}
        disabled={disableOtherName}
        fullWidth
        slotProps={{ htmlInput: { maxLength: 50 } }}
      />
    </Stack>
  )
}

export default BeneficiaryForm
